<template>
  <div>
    <div class="row" style="flex-wrap: wrap !important">
      <div
        class="col col-lg-3 col-md-4 col-sm-12 col-12 card card-custom mb-2 example example-compact"
      >
        <soha-resume-filter
          @filter="onQueriesReceived"
          ref="resumeFilter"
          @onDeleteFilter="currentPage = 1"
        />
      </div>
      <div class="col col-lg-9 col-md-8 col-sm-12 col-12">
        <div
          class="card card-custom mb-2 example example-compact"
          :class="!resumes.length && 'soha-sticky'"
        >
          <soha-page-loading v-if="loading" />
          <div v-else>
            <div class="row m-0 bg-white p-4 justify-content-between">
              <div class="d-flex justify-content-center align-items-center">
                <h3 style="color: var(--primary-color)">
                  {{ $t(`${I18nPrefix}TOTAL_NUMBER_OF_RESULT_TXT`) + " :" }}

                  <span style="color: var(--secondary-color)">
                    {{ toPersianDigits(+totalResumeCount) }}
                  </span>

                  <span class="mx-2">{{ $t(`${I18nPrefix}RESUME_TXT`) }}</span>
                </h3>
              </div>

              <div class="d-flex justify-content-center align-items-center">
                <soha-send-group-message
                  @hide="replaceResumeIds"
                  ref="sendGroupMessage"
                  class="mx-3"
                  :resume-ids="resumeIds"
                >
                  <soha-button
                    :disable="resumeIds.length === 0"
                    @click="$bvModal.show('send-message-modal')"
                    :text="$t(`${I18nPrefix}SEND_GROUP_MESSAGE`)"
                    icon="mail"
                  ></soha-button>
                </soha-send-group-message>

                <!--              <soha-order-selection-->
                <!--                @change="filterResume"-->
                <!--                :title="$t(`${I18nPrefix}ORDER_BY_TXT`)"-->
                <!--                :options="orderSelectionOption"-->
                <!--              />-->
              </div>
            </div>
            <div class="row m-0 bg-white">
              <soha-no-data
                v-if="!resumes.length"
                class="mx-auto"
                :message="$t(`${I18nPrefix}NO_RESUMES`)"
              />
              <div
                class="col col-lg-6 col-12 py-2"
                v-for="resume in resumes"
                :key="resume.id"
              >
                <soha-resume-card
                  :resume-data="resume"
                  @sendMessage="sendMessageThisResume"
                />
              </div>
            </div>
            <div class="bg-white py-2">
              <b-pagination
                v-if="totalResumeCount > perPage && !loading"
                v-model="currentPage"
                @input="goToPage"
                :total-rows="totalResumeCount"
                :per-page="perPage"
                align="center"
                pills
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SohaResumeCard from "@/view/components/resume/ResumeCard";
import SohaResumeFilter from "@/view/components/resume/ResumeFilter";
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
export default {
  name: "Index",

  mixins: [UIMixin],

  components: { SohaResumeCard, SohaResumeFilter },

  data() {
    return {
      I18nPrefix: "COMPONENTS.RESUME.RESUME_INDEX.",
      currentPage: 1,
      loading: true,
      totalResumeCount: null,
      perPage: null,
      resumes: [],
      orderSelectionOption: [
        { title: "جدید ترین", id: 1 },
        { title: "قدیمی ترین", id: 2 },
      ],
      queries: [],
      tempResumeIds: [],
      resumeIds: [],
    };
  },

  mounted() {
    this.currentPage = this.$route.query.page ? +this.$route.query.page : 1;
  },

  methods: {
    onQueriesReceived(query) {
      this.queries = query;
      this.goToPage(query.page);
    },
    filterResume() {
      this.loading = true;
      ApiService.get("api/v2/resumes", this.queries).then(({ data }) => {
        window.scrollTo(0, +this.$route.params.savedPosition);
        if (data) {
          this.resumes = data.resumes.data;
          this.totalResumeCount = data.resumeCount;
          this.tempResumeIds = data.resumeIds;
          this.resumeIds = data.resumeIds;
          this.perPage = data.resumes.per_page;
          this.resumes.map((item) => {
            let firstName = item.firstName ?? "";
            let lastName = item.lastName ?? "";
            return (item.fullName = firstName + " " + lastName);
          });
          this.loading = false;
        } else {
          this.errorToast(data.message);
        }
      });
    },

    goToPage(page) {
      this.currentPage = +page;
      const query = Object.assign({}, this.$route.query);
      query.page = this.currentPage;
      this.queries.page = this.currentPage;
      this.$router.push({ query: query });
      this.filterResume();
    },

    replaceResumeIds() {
      this.resumeIds = this.tempResumeIds;
    },
    sendMessageThisResume(id) {
      this.resumeIds = [id];
      this.$refs.sendGroupMessage.showModal();
    },
  },
};
</script>
